import { BackgroundImage, Box, Flex, Text } from 'pcln-design-system'
import React from 'react'
import styled from 'styled-components'
import PackagesBadge from './PackageBadge'

const GradientBox = styled(Box)`
  background: linear-gradient(rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.4) 80px);
`

function CardImage({
  badgeText,
  heading,
  headingColor = 'text.lightest',
  headingTextStyle = 'heading4',
  imageUrl,
}) {
  return (
    <BackgroundImage data-testid='card-image' height='152px' borderRadius='xl' rounded='top' image={imageUrl}>
      <Flex flexDirection='column' justifyContent='space-between' height='100%' width='100%'>
        {badgeText && <PackagesBadge badgeText={badgeText} mt={2} />}
        {heading && (
          <Flex width='100%'>
            <GradientBox pt={5} width='100%'>
              <Text
                enableTextShadow
                color={headingColor}
                px={3}
                py={2}
                textShadowSize='sm'
                textStyle={headingTextStyle}
              >
                {heading}
              </Text>
            </GradientBox>
          </Flex>
        )}
      </Flex>
    </BackgroundImage>
  )
}

export default CardImage
